<template>
  <DialogComponent
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
    v-loading="portReqProcessing"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">
          Toll Free Port Request
        </h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="newRequest" v-if="allowSubmit"
            >Submit</el-button
          >
          <el-button type="default" @click="cancelOperation"> Cancel</el-button>
        </div>
      </div>
    </div>
    <el-form>
      <el-input
        type="textarea"
        placeholder="Enter Numbers One Per Line"
        v-model="createForm.portNumbers"
        :autosize="{ minRows: 4 }"
      >
      </el-input>

      <el-tag class="mt-15" type="warning">
        <i class="el-icon-warning" style="margin-right: 4px;"></i>
        Uploading a LOA is required (only PNG, JPEG, PDF, and DOCX).
      </el-tag>

      <div v-if="createVisible">
        <h2 class="form-section-header">Attach LOA</h2>

        <el-upload
          class="mt-10"
          action=""
          :auto-upload="false"
          :multiple="true"
          :on-change="onLoaUpload"
        >
          <el-button size="mini" type="primary">Click to upload</el-button>
        </el-upload>

        <h2 class="form-section-header">Attach Recent Bill</h2>

        <el-upload
          class="mt-10"
          action=""
          :auto-upload="false"
          :multiple="true"
          :on-change="onRecentBillUpload"
        >
          <el-button size="mini" type="primary">Click to upload</el-button>
        </el-upload>
      </div>
    </el-form>
  </DialogComponent>
</template>

<script>
import DialogComponent from "@/components/CustomModalComponent";

export default {
  name: "TollFreePortRequest",

  props: {
    createVisible: {
      required: true
    },
    portReqProcessing: { required: true },
    clearFields: { required: true }
  },

  components: {
    DialogComponent
  },

  data() {
    return {
      createForm: {
        portNumbers: "",
        loaDocs: [],
        recentBillDocs: []
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    allowSubmit() {
      return (
        this.createForm.portNumbers &&
        this.createForm.loaDocs.length > 0
      );
    }
  },

  watch: {
    clearFields: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetFields();
        }
      }
    }
  },

  methods: {
    resetFields() {
      this.createForm = {
        portNumbers: "",
        loaDocs: [],
        recentBillDocs: []
      };
    },

    onLoaUpload(file) {
      this.createForm.loaDocs.push(file);
    },

    onRecentBillUpload(file) {
      this.createForm.recentBillDocs.push(file);
    },

    newRequest() {
      const numberArray = this.createForm.portNumbers.split(/\r?\n/);
      const trimmedNumberArray = [];

      numberArray.forEach(num => {
        const formattedNumber = this.formatNumber(num);
        const tollFreeRegex = /^(\+?1)?(8(00|33|44|55|66|77|88)[2-9]\d{6})$/;
        const isTollFree =
          formattedNumber !== "" && tollFreeRegex.test(formattedNumber);

        if (isTollFree) {
          trimmedNumberArray.push(formattedNumber);
        }
      });

      const formData = new FormData();
      formData.append("tenantId", this.selectedTenant.id);

      trimmedNumberArray.forEach(n => {
        formData.append("numberArray", n);
      });

      ["loaDocs", "recentBillDocs"].forEach(key => {
        this.createForm[key].forEach(file => {
          formData.append(key, file.raw);
        });
      });

      this.$emit("newTollFreeRequest", formData);
    },

    cancelOperation() {
      this.$emit("cancelOperation");
    },

    formatNumber(number) {
      let formattedNumber = number
        .replace(/[&\/\\#,+()$~%.'":*?<>{}-]/g, "")
        .replace(/ /g, "");
      if (formattedNumber.charAt(0) == "1") {
        formattedNumber = formattedNumber.substr(1);
      }
      return formattedNumber;
    }
  }
};
</script>

<style scoped>
.el-form {
  max-width: 600px;
  margin: 0 auto;
  padding-top: 45px;
}
</style>
